export default __webpack_public_path__ + "static/header-mail-ba3f0e6a3003057369a115f7c12ecabf.svg";